<template>
  <router-view />
</template>

<script>
import axios from 'axios';
import store from './store/index.js';
export default {
  mounted(){
    this.setAxiosDefaults();
  },
  methods: {
    setAxiosDefaults(){
      // axios.defaults.baseURL = 'http://164.90.231.202/public/api/';
      axios.defaults.baseURL = 'https://api.ppolls.com/public/api/';
      
      if(window.localStorage.getItem("BearerToken")){
        axios.defaults.headers.common.Authorization = `Bearer ${window.localStorage.getItem("BearerToken")}`
      }
    }
  }
}
</script>



<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: var(--main-background-color);
}
nav {
  padding: 30px;
}
</style>
